import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { TrashIcon, ViewIcon, CleanIcon, AddWhiteIcon, TrashWhiteIcon, ConfirmIcon, EditIcon } from 'assets/icons';
import { Input, Pagination, Table, Modal, Tooltip } from 'components';
import ModalCreateProduct from './modal-create-product';
import { ProductService } from 'services';
import { Globals, checkPermission, Constants } from 'utils';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: ''
}

class Products extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Nombre del producto',
			'Presentación',
			'Categoría',
			'Precio Unitario (US$)',
			'Existencia',
			'Acciones'
		],
		visible: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Productos',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await ProductService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.products.rows,
			last_page: res.products.count
		});
	}	

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	delete = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el producto?',async () => {
			await ProductService.admin.delete({
				product_id: item.id
			});
			this.load(true);
		});
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			item,
			visible: true
		});
	}
	
	render() {
		const { visible } = this.state;

		return (
			<div id="admin-shop-products">
				<Modal
		          className="modal-create-product"
		          visible={ visible }
		          title=""
		          centered
		          withoutClose={ true }
		          onClose={ () => this.onClose() }
		        >
					<ModalCreateProduct 
						title={ `${ this.state.item != null ? 'Editar' : 'Crear' } producto` }
						item={ this.state.item }
						onClose={ () => this.onClose() }
					/>
		      	</Modal>

				<BackComponent />

				<div className="row row-filter">
					<div className="col-md-8">
						<div className="row">
							<div className="col-md-5">
								<Input
									searchLeft
									value={ this.state.form.search }
									name="search"
									placeholder="Nombre del producto"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-4 text-right">
						{
							checkPermission(Constants.MODULES.PRODUCTS,'write') && (
								<button className="btn btn-add" onClick={ () => this.add() }>
									<img src={ AddWhiteIcon } />
								</button>
							)
						}
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i?.name }</td>
								<td>{ i?.presentation?.name }</td>
								<td>{ i?.category?.name }</td>
								<td>{ Globals.formatMiles(i?.price) }</td>
								<td>{ i?.stock }</td>
								<td>
									{
										checkPermission(Constants.MODULES.PRODUCTS,'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.PRODUCTS,'delete') && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
													<img src={ TrashIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(Products);